export default {
  GET_SHARE_ARTICLE_PAGE_INFO: '/LearnGraphic/ShareInfo', // 获取学知识落地页面信息
};
